import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, computed, input } from '@angular/core';
import { BuildingDetailsHeader } from '@cfp/features-shared/building';
import { ReportBuildingEnergyLabelAlert, ReportPage } from '@cfp/features-shared/portfolio-buildings-roadmap-report';
import { Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  AddressDetailsDTO,
  BuildingDetailsDTO,
  LloydsDecarbonisationPathwayDTO,
  PortfolioBuildingsRoadmapBuildingDTO
} from 'csr-asset-app';
import { EnergyLabelRequirementDTO } from 'csr-energy-label-requirement';
import { LbgDecarbonisationPathwayChart } from '../lbg-decarbonisation-pathway-chart';

const TRANSLATION_KEY_PREFIX = 'lbgPortfolioRoadmapReport';

/** Title + description + total + chart (~1248×438); used for same-page fit checks. */
export const LBG_BUILDING_PATHWAY_EMBEDDED_HEIGHT = 780;

@Component({
  selector: 'cfp-lbg-report-building-decarbonisation-page',
  templateUrl: 'lbg-report-building-decarbonisation-page.html',
  styleUrls: ['lbg-report-building-decarbonisation-page.scss'],
  imports: [
    NgTemplateOutlet,
    ReportPage,
    BuildingDetailsHeader,
    ReportBuildingEnergyLabelAlert,
    LbgDecarbonisationPathwayChart,
    Icon,
    TranslateModule,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgReportBuildingDecarbonisationPage {
  public readonly building = input.required<PortfolioBuildingsRoadmapBuildingDTO>();
  public readonly pathway = input.required<LloydsDecarbonisationPathwayDTO>();
  public readonly customerName = input.required<string>();
  public readonly headerLogo = input<string | undefined>(undefined);
  public readonly chromeFooter = input<TemplateRef<unknown> | undefined>(undefined);
  /** When true, render below tables on the same report page (no page chrome / building header). */
  public readonly embedded = input(false);
  public readonly lastPage = input(false);

  protected readonly translationKeyPrefix = TRANSLATION_KEY_PREFIX;

  protected readonly energyLabelRequirement = computed(
    () => this.building()?.energyLabelRequirement as EnergyLabelRequirementDTO
  );

  protected readonly buildingDetails = computed(() => {
    const addressDetails: Partial<AddressDetailsDTO> = {
      display: this.building().building.displayAddress,
      monument: this.building().building.monument
    };
    const buildingDetails: Partial<BuildingDetailsDTO> = {
      address: addressDetails as AddressDetailsDTO,
      id: this.building().building.id
    };
    return buildingDetails as BuildingDetailsDTO;
  });
}
